import * as React from 'react';

import { requestPut } from '../../../../../modules/request/index';
import useModalAccessibility from '../../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../../shared/demoGuardedButton';

export const DUPLICATE_NAME_FAILURE = 'Could not reopen activity pack because an active pack already has the same name'
export const GENERIC_FAILURE = 'Something went wrong. Not all changes were saved.'

function failureMessage(response) {
  return response?.errors?.name ? DUPLICATE_NAME_FAILURE : GENERIC_FAILURE
}

const ReopenUnitModal = ({ onSuccess, closeModal, unitId, notice = null, additionalUnitIds = [], onFailure = null, openViewName = 'My Open Activity Packs', }) => {
  const { modalRef } = useModalAccessibility(closeModal);

  function handleReopenUnitButtonClick() {
    const unitIds = [unitId, ...additionalUnitIds]
    let remaining = unitIds.length
    let firstFailure = null
    const settle = (failure?: string) => {
      firstFailure = firstFailure || failure
      remaining -= 1
      if (remaining > 0) { return }
      firstFailure ? onFailure(firstFailure) : onSuccess('Activity pack reopened')
    }
    unitIds.forEach(id => {
      const request = requestPut(`/teachers/units/${id}/open`, {}, () => settle(), onFailure ? response => settle(failureMessage(response)) : undefined)
      if (onFailure) { request?.catch?.(() => settle(GENERIC_FAILURE)) }
    })
  }

  return (
    <div className="modal-container archive-activity-pack-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="reopenActivityPackModalTitle"
        aria-modal="true"
        className="archive-activity-pack-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="reopenActivityPackModalTitle">Reopen this activity pack?</h3>
        </div>
        <div className="archive-activity-pack-modal-text">
          {notice}
          <p>This activity pack will move to the “{openViewName}” tab.</p>
          <p>Activities that students have not completed will be added to their “To-do activities” list.</p>
        </div>
        <div className="form-buttons">
          <button className="quill-button outlined medium grey focus-on-light" onClick={closeModal} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button contained medium green focus-on-light" onClick={handleReopenUnitButtonClick}>Reopen pack</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ReopenUnitModal
